import templateUrl from './overview-template.html';

export const overviewTemplateComponent = {
	bindings:{
		details: '<',
		disableButtons:'<',
		pageName:'@',
		onCancel: '&', 
		onSubmit: '&',
		onCoverPicUpload: '&',
		isDescriptionAvailable: '@'
	},

	templateUrl,

	controller: class OverviewTemplateComponent {
		constructor($parse) {
			'ngInject';

			this.$parse = $parse;
		}

		$onInit() {
			this.displayCoverPic = this.details.image ? true : false;
			this._isDescriptionAvailable = this.$parse(this.isDescriptionAvailable || 'true')(true);
			this.maxOverviewCharacterCount = 150;
			this.maxDescriptionCharacterCount = 2000;
		}

		_onCoverPicUpload(details) {
			this.onCoverPicUpload({details});
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/overview-template/overview-template.component.js